/* sh-load-more.js — resilient "Laad nog X meer" for collection pages.
 *
 * Why this exists: collection.js renders the grid + filters from /data/*.json
 * and binds its own (client-data) load-more. When that data layer is missing
 * (e.g. the Files 404), collection.js bails in its catch block and never binds
 * anything — leaving the server-rendered {% paginate %} link, which navigates
 * and jumps to the top. This module is self-contained: it appends the NEXT
 * page's server-rendered cards via AJAX, with no /data/ dependency and no
 * scroll jump. It stays dormant when collection.js client-render is healthy
 * (collection.js sets document.body.dataset.clientPaginated).
 *
 * Loaded AFTER collection.js in theme.liquid; both are `defer`. The dormant
 * check happens at CLICK time (not init) because collection.js sets its flag
 * asynchronously after its fetch resolves.
 */
(function () {
  var grid = document.getElementById('products-grid');
  if (!grid) return;

  var btn = document.querySelector('[data-load-more]') ||
    (grid.parentElement && grid.parentElement.querySelector('a.cta-pill[href*="page="]'));
  if (!btn) return;

  var wrap = btn.closest('[data-load-more-wrap]') || btn.parentElement;
  var iconEl = btn.querySelector('svg');
  var iconHTML = iconEl ? iconEl.outerHTML : '';
  var busy = false;

  function nextButtonIn(doc) {
    return doc.querySelector('[data-load-more]') ||
      doc.querySelector('a.cta-pill[href*="page="]');
  }

  btn.addEventListener('click', function (e) {
    // collection.js client-render is healthy → it owns pagination; stand down.
    if (document.body.dataset.clientPaginated) return;
    // Let modifier / middle-click open the next page natively (new tab etc).
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var url = btn.getAttribute('href');
    btn.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('products-grid');
        if (nextGrid) {
          var before = grid.children.length;
          grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
          // Mark appended cards visible (the global .reveal observer won't see
          // dynamically inserted nodes).
          for (var i = before; i < grid.children.length; i++) {
            var card = grid.children[i];
            card.classList.add('in');
            var nested = card.querySelectorAll ? card.querySelectorAll('.reveal') : [];
            for (var j = 0; j < nested.length; j++) nested[j].classList.add('in');
          }
        }
        // Advance the button to the page-after-next, or hide it when exhausted.
        var nb = nextButtonIn(doc);
        var nbHref = nb && nb.getAttribute('href');
        if (nbHref) {
          btn.setAttribute('href', nbHref);
          var label = btn.querySelector('[data-load-more-label]');
          var nbText = (nb.textContent || '').replace(/\s+/g, ' ').trim();
          if (label) { if (nbText) label.textContent = nbText; }
          else if (nbText) btn.innerHTML = nbText + ' ' + iconHTML;
        } else if (wrap) {
          wrap.classList.add('hidden');
        }
      })
      .catch(function (err) {
        // Never make it worse than the plain link: fall back to navigation.
        if (window.console) console.error('[sh-load-more]', err);
        window.location.href = url;
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
      });
  });
})();
